module.exports = __webpack_public_path__ + "images/testimonial-lee-mcfarling.webp";